import styled from 'styled-components';

import { Grid } from '@simplywallst/ui-core';

export const Overlay = styled(Grid)`
  overflow-y: hidden;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: white;
  z-index: 9999;
  padding-top: ${({ theme }) =>
    `calc(${theme.x2spacePx}px + ${theme.safeAreaInsetTop})`};
  background-color: ${({ theme }) => theme.color.noir};
`;
